import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import styled from 'styled-components';
import { textAlign } from '../../node_modules/styled-system/dist/index.esm.js';
import { Box } from '../layout/Box.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
var ModalTitle = styled(Box)(css({
  fontWeight: 600,
  flexGrow: 1
}), variant({
  variants: {
    small: {
      paddingX: "24px",
      fontSize: ["heading.sm", "heading.lg"],
      lineHeight: ["heading.sm", "heading.lg"],
      textAlign: "center"
    },
    default: {
      paddingX: ["16px", "24px"],
      paddingTop: ["66px", "0"],
      paddingBottom: ["8px", "0"],
      fontSize: ["heading.xxxl", "heading.lg"],
      lineHeight: ["heading.xxxl", "heading.lg"],
      textAlign: ["left", "center"]
    }
  }
}), textAlign);
ModalTitle.defaultProps = {
  variant: "default"
};
export { ModalTitle };